import { Component, OnDestroy, OnInit } from '@angular/core';
import { AccountService } from '../../services/account.service';
import {Configuration} from '../../configuration';
import {AuthService} from '../../auth/auth.service';
import { LoggedInUser, LoggedInUserService } from '../../auth/logged.in.user';
import { AboutBidManagementUserType, CmsHelpService, FaqUserType } from '../../services/cms.help.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
    selector: 'account/bidManagement',
    template: require('./bid.management.component.html'),
    styles: [require('./personal.account.shared.css'), require('./bid.management.component.css')]
})
export class BidManagementComponent implements OnInit, OnDestroy {
    isBidManager: boolean;
    isTeamMember: boolean;
    newBidManager: boolean;
    mustValidateEmail: boolean;
    loggedInUser: LoggedInUser;
    userType: AboutBidManagementUserType;
    htmlContent: string = ""
    paid: boolean;
    isEmailValidated: boolean;
    @BlockUI('bid-mgt-block') private bidMgtBlock: NgBlockUI;

    constructor(private readonly accountService: AccountService,
        private readonly config: Configuration,
        private readonly authService: AuthService,
        private helpService: CmsHelpService,
        public userService: LoggedInUserService) {

        this.accountService.isEmailValidated().subscribe((response: boolean) => {
            this.isEmailValidated = response;

            this.loggedInUser = this.userService.getCurrentUser();
            this.isBidManager = this.loggedInUser.canAdHoc('bidManagerDashboard');

            this.paid = !this.loggedInUser.canAdHoc('notSubscribed');

            if (this.loggedInUser.role == "Tender Team Member") {
                this.isTeamMember = true;
            }
            else {
                this.isTeamMember = false;
            }

            if (this.isTeamMember) {
                this.userType = AboutBidManagementUserType.TeamMember;
            }
            else {
                this.userType = this.paid ?
                    this.isBidManager ? AboutBidManagementUserType.PaidFull : AboutBidManagementUserType.PaidFullBeforeBid
                    : this.isBidManager ? AboutBidManagementUserType.FreeTrialStarted : AboutBidManagementUserType.BeforeFreeTrialValidated;
            }

            this.helpService.getByBidType(this.userType).subscribe((response: any) => {
                this.htmlContent = response.result.content;
            });

        });

    }

    ngOnInit(): void {
        document.body.classList.add('personal-account-fit');
    }

    ngOnDestroy(): void {
        document.body.classList.remove('personal-account-fit');
    }

    linkAccount() {
        this.bidMgtBlock.start('Your Bid Management Account is being created');
        this.accountService.becomeBidManager().subscribe(
            (response: any) => {
                this.newBidManager = true;
                this.mustValidateEmail = false;
                this.authService.getNewToken().subscribe(
                    () => {
                        window.location.reload();
                        this.bidMgtBlock.stop();
                    },
                    (error: any) => {
                        // Handle error for getting new token
                        console.error('Error getting new token:', error);
                        this.bidMgtBlock.stop(); // Stop bid management block
                        window.location.reload();
                    }
                );
            },
            (error: any) => {
                // Handle error for becoming bid manager
                console.error('Error becoming bid manager:', error);
                this.bidMgtBlock.stop(); // Stop bid management block
            }
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/account.management/bid.management.component.ts